import { useSettings } from '../settings';

export default function ContactSection({ children }) {
  const { t } = useSettings();
  return (
    <aside id="contact" className="contact-curtain" aria-label={t('contact.sectionLabel')}>
      {children}
    </aside>
  );
}
